import AccountingAuthResult from './AccountingAuthResult';

export default AccountingAuthResult;

